import React from 'react';
import { makeStyles, tokens, Tooltip } from '@fluentui/react-components';
import { DocumentTextColor } from '@fluentui/react-icons';

const useStyles = makeStyles({
  indicator: {
    display: 'inline-flex',
    flexShrink: 0,
    marginLeft: tokens.spacingHorizontalXS,
  },
  icon: {
    fontSize: tokens.fontSizeBase500,
  },
});

const EntityTerminationDocumentIndicator = (): JSX.Element => {
  const styles = useStyles();

  return (
    <Tooltip content="Documents uploaded" relationship="label" withArrow>
      <span aria-label="Documents uploaded" className={styles.indicator} role="img">
        <DocumentTextColor aria-hidden className={styles.icon} />
      </span>
    </Tooltip>
  );
};

export default EntityTerminationDocumentIndicator;
